// extracted by mini-css-extract-plugin
export default {"container":"UsefulLinksAndroid_container__g8z+X"};